<template>
  <div>
    <LogoImage :width="width" />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '45px',
    },
  },
}
</script>
